import { SystemStyleObject } from '@chakra-ui/react';

interface NotificationsButtonSx {
  button: SystemStyleObject;
}

export const notificationsButtonSx: NotificationsButtonSx = {
  button: {
    display: 'flex',
    cursor: 'pointer',
    mr: { base: 4, lg: 6 },
    WebkitAppRegion: 'no-drag',
  },
};
